export const MarkersNavLink = 'markers';
